module.exports = __webpack_public_path__ + "static/fourpcbunnymain-435f522f1c22ee0db8d350c0726fcefe.jpeg";